<template>
  <div :style="{ position: 'relative', paddingTop: `${((1 / info.aspect) * 100)}%` }">
    <PlayerFrame v-if="refObject.$isInit" :refObject="refObject" :info="info"/>
    <PosterFrame v-if="!refObject.$isInit" :refObject="refObject" :info="info" :onPlay="handlePlay"/>
  </div>
</template>

<script>
import PosterFrame from './PosterFrame';
import PlayerFrame from './PlayerFrame';

export default {
  props: ['info', 'refObject'],
  components: {
    PosterFrame,
    PlayerFrame,
  },
  methods: {
    handlePlay() {
      this.refObject.$init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// App.vue?4550612b